import React from "react";
import PropTypes from "prop-types";
// import "../../../App.css";
import Background from "../../../assets/img/new-logo-4-bg.png";
import {
  fetchMedicalRecords,
  getDeletable,
  recoverMRecords,
  updatePrintMRecord,
  fetchDeletedMedicalRecords
} from "./../../../actions/medicalRecords";
import { fetchAnimalTypes } from "../../../actions/addAnimalType";
import { fetchRegTypes } from "../../../actions/regType";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import NewMRecordForm from "../add";
import AvatarEditor from "react-avatar-editor";
import history from "../../../history.js";
import moment from "moment";
import { Loader } from "../../../components/loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { BreadCrumb } from "../../../components/breadcrumb";
import MRecordPDF from "../../../components/mRecordPdf/mRecordPdf";
import DoPdf from "../../../components/doPdf/doPdf";

const $ = window.$;
const { SearchBar } = Search;

const genderOptions = {
  0: "male",
  1: "female"
};

const cbOptions = {
  0: "yes",
  1: "no"
};

const statusOptions = {
  0: "Available",
  1: "Draft",
  2: "Sold"
};

var toaOptions = {};
var rtOptions = {};
var tableHeaderColumnData = [];

class DeletedMedicalRecords extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    openNew: false,
    confirmDelete: false,
    contentData: [],
    cdAvailable: [],
    cdDraft: [],
    cdSold: [],
    cdDeleted: [],
    selected: [],
    loadingDelete: false,
    loadingRecover: false,
    deleteMRId: null,
    recoverMRId: null,
    selectedTab: "All",
    clickedId: "",
    clickedIdDoPdf: ""
  };

  tableHeaderColumnData = [
    {
      dataField: "actions",
      text: "Actions",
      formatter: this.buttonFormatter.bind(this),
      style: { "overflowX": "visible" }
    },

    {
      dataField: "pet_id",
      text: "Pet ID",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.avatar_path +
                "/" +
                row.avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />
            <span className="m-badge m-badge--info mx-auto my-0 px-2">
              <strong>{cell}</strong>
            </span>
          </span>
        );
      }
    },
    {
      dataField: "breed_type",
      text: "Breed",
      sort: true
    },
    {
      dataField: "sex",
      text: "Gender",
      sort: true,
      formatter: cell => cell
    },
    {
      dataField: "color_markings",
      text: "Color",
      sort: true
    },
    {
      dataField: "date_of_birth",
      text: "Date Of Birth",
      formatter: cell => moment(cell).format("MM-DD-YYYY"),
      sort: true
    },
    {
      dataField: "arrival_date",
      text: "Arrival Date",
      formatter: cell => moment(cell).format("MM-DD-YYYY"),
      sort: true
    },

    {
      dataField: "reg_type",
      text: "Registration Type",
      sort: true,
      formatter: cell => cell
    },
    {
      dataField: "breeder",
      text: "Breeder",
      sort: true
    },
    {
      dataField: "breeder_phone",
      text: "Breeder Phone",
      formatter: cell => <a href={`tel:${cell}`} className="hyperlink-phone-number">{cell}</a>,
      sort: true
    },
    {
      dataField: "usda_no",
      text: "USDA",
      sort: true
    },

    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span
            className={
              "m-badge mx-auto my-0 px-2 " +
              (cell === "Available"
                ? "m-badge--success"
                : cell === "Sold"
                ? "m-badge--danger"
                : " m-badge--wide")
            }
          >
            <strong>{cell}</strong>
          </span>
        );
      }
    }
  ];

  buttonFormatter(cell, row) {
    return (
      <div>
        <span className="dropdown show">
          <span className="dropdown">
            <a
              href=""
              className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i className="la la-ellipsis-h"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">

              <a
                className="dropdown-item"
                onClick={(e) => this.openRecoverConfirmModal(e,row.id)}
              >
              <i className="la la-undo"></i> Recover

              </a>

              <a
                className="dropdown-item"
                onClick={(e) => {
                    this.openConfirmModal(e,row.id)
                }}
              >
                <i className="la la-trash-o"></i> Delete Permenetly
              </a>
            </div>
          </span>
        </span>
      </div>
    );
  }

  openPdf = (e,id) => {
    e.preventDefault();
    if (this.state.clickedId !== id) {
      this.setState({ clickedId: id });
    } else {
      if (this.props.data.medicalRecordsReducer.printMRecord)
        this.childDownload();
    }
  };

  openDoPdf = (e,id) => {
    e.preventDefault();
    if (this.state.clickedIdDoPdf !== id) {
      this.setState({ clickedIdDoPdf: id });
    } else {
      if (this.props.data.medicalRecordsReducer.printMRecord)
        this.childDoDownload();
    }
  };

  acceptMethods(childDownload) {
    // Parent stores the method that the child passed
    this.childDownload = childDownload;
  }

  acceptMethodsForPdf(childDoDownload) {
    // Parent stores the method that the child passed
    this.childDoDownload = childDoDownload;
  }

  openRejectModal(e) {
    e.preventDefault();
    $("#reject_modal").modal("show");
  }

  openConfirmModal(e, mrId) {
    e.preventDefault();
    this.setState({ deleteMRId: mrId });
    $("#confirm_delete_modal").modal("show");
  }

  openRecoverConfirmModal(e, mrId) {
    e.preventDefault();
    this.setState({ recoverMRId: mrId });
    $("#confirm_recover_modal").modal("show");
  }

  componentDidMount() {
    this.props.fetchDeletedMedicalRecords();
    this.props.fetchAnimalTypes();
    this.props.fetchRegTypes();
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.toa !== nextProps.toa) {
      let i = 0;
      for (let t of nextProps.toa) {
        toaOptions[i] = t.type;
        i++;
      }
    }
    if (this.props.reg_types !== nextProps.reg_types) {
      let i = 0;
      for (let t of nextProps.reg_types) {
        rtOptions[i] = t.type;
        i++;
      }
    }
    // if((this.props.toaError!==nextProps.toaError)||(this.props.reg_types_error!==nextProps.reg_types_error )||(this.props.mRecordsError!==nextProps.mRecordsError )){
    //   NotificationManager.error("Something went wrong.");
    // }
    if (
      nextProps.data.medicalRecordsReducer.mRecord !==
      this.props.data.medicalRecordsReducer.mRecord
    ) {
      this.props.fetchDeletedMedicalRecords();
    }
    if (
      nextProps.data.medicalRecordsReducer.dMRecords !==
      this.props.data.medicalRecordsReducer.dMRecords
    ) {
      let records = nextProps.data.medicalRecordsReducer.dMRecords;

      records.sort((a, b) => (a.id > b.id ? -1 : 1));
      
      let cdDraft = records.filter(
        m => m.status === "Draft"
      );
      let cdAvailable = records.filter(
        m => m.status === "Available"
      );
      let cdSold = records.filter(
        m => m.status === "Sold"
      );
      
      let cdDeleted = records.filter(
        m => m.status === "Deleted"
      );
      

      this.setState({
        contentData: records,
        cdAvailable: cdAvailable,
        cdSold: cdSold,
        cdDraft: cdDraft,
        cdDeleted: cdDeleted
      });
    }
    if (
      nextProps.data.medicalRecordsReducer.selectedToDelete !==
      this.props.data.medicalRecordsReducer.selectedToDelete
    ) {
      this.setState({ loadingDelete: false });
      this.setState({ loadingRecover: false });
      this.props.fetchDeletedMedicalRecords();
      NotificationManager.success("Medical Record Deleted Successfully");
      $("#confirm_delete_modal").modal("hide");
    }

    if (
        nextProps.data.medicalRecordsReducer.recoveredMRecord !==
        this.props.data.medicalRecordsReducer.recoveredMRecord
      ) {
        this.setState({ loadingDelete: false });
        this.setState({ loadingRecover: false });
        this.props.fetchDeletedMedicalRecords();
        NotificationManager.success("Medical Record Recovered Successfully");
        $("#confirm_recover_modal").modal("hide");
      }

    if (
      nextProps.data.medicalRecordsReducer.mRecord !==
      this.props.data.medicalRecordsReducer.mRecord
    ) {
      this.props.fetchDeletedMedicalRecords();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.clickedId && this.state.clickedId !== prevState.clickedId) {
      this.props.updatePrintMRecord(this.state.clickedId);
      // await this.setState({clickedId: undefined});
    }

    if (this.state.clickedIdDoPdf && this.state.clickedIdDoPdf !== prevState.clickedIdDoPdf) {
      this.props.updatePrintMRecord(this.state.clickedIdDoPdf);
      // await this.setState({clickedId: undefined});
    }
    
    if (
      this.props.data.medicalRecordsReducer.printMRecord &&
      prevProps.data.medicalRecordsReducer.printMRecord !==
      this.props.data.medicalRecordsReducer.printMRecord
    ) {

      if(this.state.clickedIdDoPdf){
        this.childDoDownload();
      }

      if(this.state.clickedId){
        this.childDownload();
      }

    }
  }

  handleClickOpen = () => {
    this.setState({ openNew: true });
  };

  handleClose = value => {
    this.props.reset("newContractForm");
    this.setState({ openNew: false, confirmDelete: false });
    this.props.fetchDeletedMedicalRecords();
  };

  handleDeleteConfirm = () => {
    this.props.getDeletable(this.state.selected);
    this.handleClose();
  };

  handleDelete = selected => {
    if (!(selected === null || selected === undefined) && selected !== 0) {
      this.setState({ confirmDelete: true, selected });
    }
  };

  deleteMRecord() {
    this.setState({ loadingDelete: true });

    if (this.state.deleteMRId) this.props.deleteMRecords(this.state.deleteMRId);
    else {
      NotificationManager.warning("Invalid medical record.");
      this.setState({ loadingDelete: false });
    }
  }

  recoverMRecord(){
    this.setState({ loadingRecover: true });

    if (this.state.recoverMRId) this.props.recoverMRecords(this.state.recoverMRId);
    else {
      NotificationManager.warning("Invalid medical record.");
      this.setState({ loadingRecover: false });
    }
  }

  handleChildUnmount(){
    this.setState({clickedId: false});
  }

  handleChildUnmountDoPdf(){
    this.setState({clickedIdDoPdf: false});
  }

  items = [{ title: "Medical Records", to: "/medical-records" }];

  handleRedirectClick = () => {
    this.props.history.push("/medical-records");
  }

  render() {
    const { classes, theme, pdfStatus } = this.props;
    const { contentData, cdAvailable, cdSold, cdDraft, cdDeleted } = this.state;

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Deleted Medical Records
                        <small>List of all the deleted medical records</small>
                      </h3>
                    </div>
                  </div>
                  <div className="m-portlet__head-tools">
                    <NavLink
                      to={`/medical-records/add`}
                      className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
                    >
                      <span>
                        <i className="la la-plus"></i>
                        <span>New Medical Record</span>
                      </span>
                    </NavLink>
                  </div>
                </div>
                <div className="m-portlet__body">
                  <ul
                    className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                    role="tablist"
                  >
                    {/* <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "All"
                        })}
                        onClick={() => this.setState({ selectedTab: "All" })}
                      >
                        All
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Available"
                        })}
                        onClick={() =>
                          this.setState({ selectedTab: "Available" })
                        }
                      >
                        Available
                      </a>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Draft"
                        })}
                        onClick={() => this.setState({ selectedTab: "Draft" })}
                      >
                        Draft
                      </a>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Sold"
                        })}
                        onClick={() => this.setState({ selectedTab: "Sold" })}
                      >
                        Sold
                      </a>
                    </li> */}
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "GoBack"
                        })}
                        onClick={() => this.handleRedirectClick()}
                      >
                        Go Back
                      </a>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <ToolkitProvider
                      keyField="id"
                      data={
                        this.state.selectedTab === "All"
                          ? contentData
                          : this.state.selectedTab === "Available"
                          ? cdAvailable
                          : this.state.selectedTab === "Sold"
                          ? cdSold
                          : this.state.selectedTab === "cdDeleted"
                          ? cdDeleted
                          : this.state.selectedTab === "Draft"
                          ? cdDraft
                          : {}
                      }
                      columns={this.tableHeaderColumnData}
                      search                      
                      hover={true}
                      filter={filterFactory()}
                    >
                      {props => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon">
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                            </div>
                          </div>
                          <div className="mb-2">
                            <small className="small-text">
                              *If you experience any difficulty in viewing the
                              medical record, please make sure your cache is
                              cleared and completed a hard refresh. IOS users
                              might have to use a private window.
                            </small>
                          </div>
                          {!pdfStatus ?
                          <BootstrapTable 
                            classes="petTable"
                            {...props.baseProps}
                            pagination={paginationFactory()}
                          />
                          : <div className={"loader-center"}>
                              <Loader
                              type="line-scale"
                              active={true}
                              className="loader-center"
                            />
                            </div>}
                        </div>
                      )}
                    </ToolkitProvider>
                    {/* {this.state.selectedTab === 'All' && */}
                    {/* <div className="tab-pane active" id="m_tabs_6_1" role="tabpanel">
                        <BootstrapTable classes="petTable" keyField="id" columns={this.tableHeaderColumnData} data={this.state.selectedTab === 'All' ? contentData : this.state.selectedTab === 'Available' ? cdAvailable : this.state.selectedTab === 'Sold' ? cdSold : this.state.selectedTab==='Draft'?cdDraft : {}} defaultSortDirection="asc" hover={true} pagination={ paginationFactory() } filter={ filterFactory() } />
                      </div> */}
                    {/* }
                    {this.state.selectedTab === 'Available' &&
                      <div className="tab-pane" id="m_tabs_6_2" role="tabpanel">
                        <BootstrapTable classes="petTable" keyField="id" columns={this.tableHeaderColumnData} data={cdAvailable} defaultSortDirection="asc" hover={true} pagination={ paginationFactory() } filter={ filterFactory() } />
                      </div>
                    }
                    {this.state.selectedTab === 'Sold' &&
                      <div className="tab-pane" id="m_tabs_6_3" role="tabpanel">
                        <BootstrapTable classes="petTable" keyField="id" columns={this.tableHeaderColumnData} data={cdSold} defaultSortDirection="asc" hover={true} pagination={ paginationFactory() } filter={ filterFactory() } />
                      </div>
                    } */}
                  </div>
                </div>
              </div>
                    
              <div
                className="modal fade"
                id="confirm_delete_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Confirm to delete
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete this medical record?
                      </p>
                    </div>
                    <div className="modal-footer">
                      {this.state.loadingDelete == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => this.deleteMRecord()}
                            className="btn btn-primary m-btn--pill"
                          >
                            Confirm
                          </button>
                        </div>
                      ) : (
                        <div className="center-row">
                          <Loader size={50} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="confirm_recover_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Confirm to recover
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to recover this medical record?
                      </p>
                    </div>
                    <div className="modal-footer">
                      {this.state.loadingRecover == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => this.recoverMRecord()}
                            className="btn btn-primary m-btn--pill"
                          >
                            Confirm
                          </button>
                        </div>
                      ) : (
                        <div className="center-row">
                          <Loader size={50} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>          

              <div
                className="modal fade"
                id="reject_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="RejectModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Not allowed
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        This medical record is associated with a contract.
                        Please delete the contract first.
                      </p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-primary m-btn--pill mx-2"
                        data-dismiss="modal"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        </div>
        {this.state.clickedId ? <MRecordPDF setClick={this.acceptMethods.bind(this)} unmountMe={this.handleChildUnmount.bind(this)} /> : null}
        {this.state.clickedIdDoPdf ? <DoPdf setClick={this.acceptMethodsForPdf.bind(this)} unmountMe={this.handleChildUnmountDoPdf.bind(this)} /> : null}
        
      </div>                
    );
  }
}

const mapStateToProps = state => ({
  data: state,
  toa: state.addAnimalTypeReducer.animalTypes,
  reg_types: state.regTypeReducer.regTypes,
  toaError: state.addAnimalTypeReducer.animalTypesError,
  reg_types_error: state.regTypeReducer.regTypesError,
  mRecordsError: state.medicalRecordsReducer.mRecordsError,
  pdfStatus: state.medicalRecordsReducer.pdfStatus
});

const mapDispatchToProps = dispatch => ({
  fetchDeletedMedicalRecords: () => {
    dispatch(fetchDeletedMedicalRecords());
  },
  fetchAnimalTypes: () => {
    dispatch(fetchAnimalTypes());
  },
  fetchRegTypes: () => {
    dispatch(fetchRegTypes());
  },
  deleteMRecords: selected => {
    dispatch(getDeletable(selected));
  },
  recoverMRecords: selected => {
    dispatch(recoverMRecords(selected));
  },

  updatePrintMRecord: id => {
    dispatch(updatePrintMRecord(id));
  }
});

DeletedMedicalRecords = connect(mapStateToProps, mapDispatchToProps)(DeletedMedicalRecords);

export default withRouter(DeletedMedicalRecords);
